/* eslint semi:0 */
import BaseVm from './BaseVm'
import { nodes } from '../../utils/dom'
import { m } from '../../utils/mithril'
import slideshowStore from '../stores/slideshowStore'
import * as slideshowActions from '../actions/slideshowActions'
import { MOUNT_POINTS } from '../../config/preRenderedSelectorsConfig'

class SlideshowVm extends BaseVm {
  startSlideChange(slideEventObject) {
    slideshowActions.startSlideChange(slideEventObject)
    return this
  }

  onChange(slideId) {
    this.newSlideIndex = slideId
    m.redraw()
  }

  get newSlideIndex() {
    return this.state.newSlideIndex
  }
  set newSlideIndex(slideId) {
    this.state.newSlideIndex = slideId
  }
  get scrollPosition() {
    return this.state.currentScrollPosition || 0
  }
  set scrollPosition(bool) {
    this.state.currentScrollPosition = bool
  }

  completeSlideChange(slideId) {
    setImmediate(() => {
      slideshowActions.completeSlideChange(slideId)
    })
  }

  slideshowInitializationFinished() {
    setImmediate(() => {
      slideshowActions.slideshowInitializationFinished()
    })
  }

  getCurrentSlideIndex(slideId) {
    return !slideId
      ? 0
      : Array.from(nodes(MOUNT_POINTS.SLIDE_CONTAINER))
          .map(function getSlideTitleAttribute(slide) {
            return slide.getAttribute('data-title-for-url')
          })
          .indexOf(slideId)
  }
}

const slideshowVm = SlideshowVm.create({ store: slideshowStore })

export default slideshowVm



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/slideshowVm.js